/**
 * useActivityTagOptions — fetches curated activity tag options from public.tags.
 * Reuses the same tags as places (category='place') since activities share the taxonomy.
 * SoT: docs/architecture/activity-tags-v1.md
 */
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface ActivityTagOption {
  slug: string;
  label: string;
}

export function useActivityTagOptions() {
  const { data, isLoading, error } = useQuery({
    queryKey: ["activity-tag-options"],
    queryFn: async (): Promise<ActivityTagOption[]> => {
      const { data, error } = await supabase
        .from("tags")
        .select("slug, label")
        .eq("category", "place")
        .eq("is_active", true)
        .order("label", { ascending: true });

      if (error) throw error;
      return (data ?? []).map((t) => ({ slug: t.slug, label: t.label }));
    },
    staleTime: 5 * 60 * 1000,
  });

  return {
    options: data ?? [],
    loading: isLoading,
    error,
  };
}
